module.exports = require("promise-timeout");